import * as React from "react";
import { ImageProps } from "../../types";

/**
 * Simple `<img>` wrapper with strongly-typed dimension and style props.
 *
 * @example
 * ```tsx
 * <Image source="/assets/logo.png" alt="Company logo" height={40} />
 * <Image source={avatarUrl} width={100} height={100} style={{ borderRadius: "50%" }} />
 * ```
 */
const Image: React.FC<ImageProps> = ({
  source,
  height,
  width,
  style,
  alt = "",
}) => {
  return (
    <img
      src={source}
      style={{ ...style }}
      height={height}
      width={width}
      alt={alt}
    />
  );
};

export default Image;
